import {
  Dag,
  TaskAction,
  isRunningStatus,
} from '@agilelab/plugin-wb-builder-common';
import { Test } from '../../../ControlPanel';
import { WbScrollable } from '@agilelab/plugin-wb-platform';
import { WbTooltip } from '@agilelab/plugin-wb-platform';
import { Box, IconButton, useTheme } from '@material-ui/core';
import { FC, Fragment } from 'react';
import { useStepIcons } from '../../hooks/useStepIcons';
import { Deploy } from '../../types';
import { extractDagName } from '../../utils';
import { ValidationGatewayStep } from './ValidationGatewayStep';

export interface DeployStepsProps {
  deploy: Deploy;
  /**
   * Resolved test for each step, keyed by subPlanId.
   * Pass an empty map (or undefined) when no pre-fetched tests are available.
   */
  testsMap: Map<string, Test>;
  onStepClick: (step: Dag, deploy: Deploy) => void;
  onValidationGatewayClick: (
    deploy: Deploy,
    subPlanId: string | undefined,
    test: Test | undefined,
  ) => void;
}

export const DeploySteps: FC<DeployStepsProps> = ({
  deploy,
  testsMap,
  onStepClick,
  onValidationGatewayClick,
}) => {
  const theme = useTheme();
  const stepIcons = useStepIcons();

  return (
    <WbScrollable>
      <Box display="flex" alignItems="center">
        {deploy.steps.map((step, index) => (
          <Fragment key={step.id}>
            {(() => {
              const stepName = extractDagName(step);
              return (
                <WbTooltip title={stepName}>
                  <IconButton
                    style={{ margin: '0px -4px' }}
                    size="small"
                    aria-label={stepName}
                    onClick={() => {
                      if (
                        !isRunningStatus(step.status) &&
                        step.action === TaskAction.VALIDATION_GATEWAY
                      ) {
                        const test =
                          (step.subPlanId && testsMap.get(step.subPlanId)) ||
                          undefined;
                        onValidationGatewayClick(deploy, step.subPlanId, test);
                      } else {
                        onStepClick(step, deploy);
                      }
                    }}
                  >
                    {step.action === TaskAction.VALIDATION_GATEWAY ? (
                      <ValidationGatewayStep
                        step={step}
                        tests={
                          (step.subPlanId && testsMap.get(step.subPlanId)) ||
                          undefined
                        }
                      />
                    ) : (
                      stepIcons[step.status]
                    )}
                  </IconButton>
                </WbTooltip>
              );
            })()}
            {index !== deploy.steps.length - 1 && (
              <Box
                style={{
                  width: '15px',
                  height: '2px',
                  background: theme.palette.grey[400],
                }}
              />
            )}
          </Fragment>
        ))}
      </Box>
    </WbScrollable>
  );
};
